import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';

import {
    FETCH
} from 'one-state-createincidents/src/types';

import {
    setAction,resetAction
} from 'one-state-createincidents/src/actions';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import {format} from 'one-util-date';

import { Disposition } from 'one-model-local';
/**
 * This Fuction will intiate screenpop via get method to
 *  backend api and returns status
 * @param context contains the settings etc..
 */
 export const enum Types {
    STORE_DISPOSITION_CODE = "store-disposition-code",
}

const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

export const fetchCreateIncidentsEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { serverone,agentId, log, settings: { compatible, epicendpoints,servers,uisettings } } = context;
        const { locations = [] } = servers;
        const {  apitoken,createincident } = epicendpoints;
        const { contact_center_type } = compatible;
        const {
            dashboardapiconfig: {
                createincident : createincidentApi
            }
        } = uisettings;
        return action$.pipe(
            ofType(FETCH),
            // ofType(Types.PatientSet),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient response
                 */
                
                 let dataresponse:any = action.payload;
                const getRequest = (payload: any) => {
               
                        let headers = new Headers();
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        headers.append("Accept", "application/json");
                        //  todo: delegate to one-server-ha oneview
                        headers.append("Content-Type", "text/plain");
                        const data= {
                            description: payload.description ? payload.description : "",
                            short_description: payload.short_description ? payload.short_description : "",
                            category: payload.category ? payload.category : "",
                            caller_id: payload.caller_id ? payload.caller_id : "",
                            state: payload.state ? payload.state : "",
                            sysparm_display_value: true,
                            sysparm_exclude_reference_link: true,
                            sysparm_fields: "number,short_description,priority,state,state,sys_id,sys_created_on",
                          }
                        const response = serverone.post({
                            path: createincident,
                            data: data,
                            headers: headers
                        })
                        .then((responsefound: any) => {
                            // treating as success for screenpop
                            
                            log.debug(
                                "ccw-gadget,screenpop-epic",
                                "screenpop-epic response", {
                                    responsefound
                            });
                            let result = responsefound;
                            return result;
                        })
                        .catch((responseresult: any) => {
                                 //Check the Side B server receive communication
                      
                            log.error(
                                "ccw-gadget,screenpop-epic",
                                "screenpop-epic", {
                                responseresult
                            }
                            );
                            let result = responseresult;
                            return result;   
                        })
                    return from(response)

                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                if (!createincidentApi) return []
                return getRequest(dataresponse).
                    pipe(
                        map((response: any) => response)
                    ).
                    pipe(
                        flatMap((response: any) => {
                                const actions:any = [
                                   setAction(response)
                                ];
                               
                                if(response?.errors && response?.errors?.length > 0){
                               /*changes for errors will pushed to bell icon*/
                                    let errorbuild:ErrorObject = {
                                   source: "CreateIncidents",
                                   type: "error",
                                   status: response?.status,
                                   erroritems: response?.errors,
                                   error_date: errorDate,
                                   error_time: errorTime
                               };
                               actions.push(addAction(errorbuild))
                               let disp: Disposition = { value: "1015" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    disp.meta00 = agentIdValue;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta01 = response?.error?.status;
                                disp.meta02 = dataresponse.caller_id;
                                disp.meta03 = 'client';
                                actions.push(pushToDisposition(disp));
                                }  else {
                                    let disp: Disposition = { value: "199" }
                                    if (contact_center_type && contact_center_type === 'five9') {
                                        let agentIdValue = sessionStorage.getItem("agentName");
                                        disp.meta00 = agentIdValue;
                                        disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                    } else {
                                        disp.meta00 = agentId;
                                        disp.dial_list_uid = state$.value.choosecaller?.callId;
                                    }
                                    disp.meta01 = dataresponse.caller_id;
                                    actions.push(pushToDisposition(disp));
                                }
                               return actions;
                           })
                    )
            })
        )
    }
);


